<template>
  <div>
    <public-title>线路行程
      <div slot="right" class="ml-auto">
        <el-button size="small" type="success" @click="$router.push({name:'addEditActivity',query:{discount:$route.query.discount}})">添加线路行程</el-button>
        <span class="text-link ml-4 h6" @click="$router.push({name:'ActivityManage'})">返回列表</span>
      </div>
    </public-title>
    <div class="load-area" v-if="discountDetail">
        <el-tabs class="topTab" v-model="activeName" @tab-click="$GFUN.pageChange(1);getDiscountDetail($route.query.discount,activeName)">
          <el-tab-pane :name="item.id" v-for="item in mealArr" :key="item.id" :label="item.name" />
        </el-tabs>
        <product-calendar v-if="activeName==3" />
        <div v-else class="p-4">
          <ul class="list-head mt-3 text-center" >
            <li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li>
          </ul>
          <p v-if="discountDetail.itineraryDetailsArr.length == 0" class="mt-3">当前没有数据</p>
          <div v-else>
            <ul class="list-item" v-for="(item,index) in discountDetail.itineraryDetailsArr" :key="index">
              <li class="w-50 list-item-col">{{item.name}}</li>
              <li class="w-50 list-item-col">
                {{item.start_time | formatTimestamp}} 至 {{item.end_time | formatTimestamp}}
              </li>
              <li class="w-50 list-item-col">{{item.day_num}}天{{item.night_num}}晚</li>
              <li class="w-50 list-item-col">
                <div class="text-link ml-auto" v-if="item.file" @click="toEleMsg(item)">{{item.file}}</div>
                <div v-else>暂无</div>
              </li>
              <li class="w-50 list-item-col flex-column">
                <div>门市价：<span class="text-blue">&yen;{{item.price1}}</span><span>/&yen;{{item.price01}}</span></div>
                <div>采购商价：<span class="text-blue">&yen;{{item.price2}}</span><span>/&yen;{{item.price02}}</span></div>
                <div>订单雨价：<span class="text-blue">&yen;{{item.price3}}</span><span>/&yen;{{item.price03}}</span></div>
              </li>
              <li class="w-50 list-item-col">
                <span :class="item.status == 1 ? 'text-success' : 'text-danger'">{{item.status == 1 ? '启用中' : '已下架'}}</span>
                <span class="text-link" @click="changeStatus(item)">{{item.status == 1 ? '（下架）' : '（上架）'}}</span>
              </li>
              <li class="w-50 list-item-col text-link">
                <span class="ml-1 mr-1" @click="$router.push({name:'addEditActivity',query:{discount:$route.query.discount,child: item.id}})">编辑</span>
                <span @click="del(item.id)">删除</span>
              </li>
            </ul>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProductCalendar from '../../Admin/VocationProductManage/ProductCalendar.vue'
export default {
    name: 'RouteChildList',
    components: {ProductCalendar},
    data () {
        return {
          activeName: '1',
          mealArr: [{id:'1',name:'已上架'},{id:'0',name:'未上架'},{id:'3',name:'线路日历'}],
          titleArr: ['名称','线路行程时效','天数','行程单','价格','状态','操作'],
        }
    },
    computed: {
      ...mapState(['discountDetail']),
    },
    created () {
      this.getDiscountDetail(this.$route.query.discount,this.activeName)
    },
    methods: {
      ...mapActions(['getDiscountDetail','deleteActiType','addEditActiType']),
      del (id) {
        this._confirm('确认删除么？',() => {
          this.deleteActiType(id);
        })
      },
      toEleMsg (item) {
        window.open(this.ImgPreUrl + item.file,'_blank')
      },
      changeStatus (item) {
        this._confirm(`确定将该线路行程${item.status ? '下架' : '上架'}么？`,() => {
          this.addEditActiType({
            type: 'edit',
            data: {
              ...item,status: item.status == 1 ? '0' : '1',
              itinerary_id: this.$route.query.discount,
              itinerary_details_id: item.id
            }
          })
        })
      }
    }
}
</script>